var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Arduino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1edd5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#009688",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,34.7c-7.7,0 -13.2,-8.9 -13.4,-9.3l-0.6,-1l0.6,-1c0.2,-0.5 5.7,-9.4 13.4,-9.4c5.7,0 10.3,4.6 10.3,10.3c0,5.7 -4.6,10.4 -10.3,10.4zM26.4,24.3c1.5,2 5.1,6.3 9.2,6.3c3.5,0 6.3,-2.8 6.3,-6.3c0,-3.5 -2.8,-6.3 -6.3,-6.3c-4.1,0 -7.7,4.3 -9.2,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,34.7c-5.7,0 -10.3,-4.7 -10.3,-10.4c0,-5.7 4.6,-10.3 10.3,-10.3c7.9,0 13.2,8.9 13.4,9.3l0.6,1l-0.6,1c-0.2,0.4 -5.7,9.4 -13.4,9.4zM12.3,18c-3.5,0 -6.3,2.8 -6.3,6.3c0,3.5 2.8,6.3 6.3,6.3c4.2,0 7.8,-4.3 9.3,-6.3c-1.4,-2 -5,-6.3 -9.3,-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,23h6v2h-6zM32,23h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,21h2v6h-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Arduino);
export default __webpack_public_path__ + "static/media/icons8-arduino.8db4bb50f11ba8ff2880cac2cf7de2df.svg";
export { ForwardRef as ReactComponent };